var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_739_1661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66666 0H4.66666C6.13941 0 7.33331 1.19391 7.33331 2.66666V4.66666C7.33331 6.13941 6.13941 7.33331 4.66666 7.33331H2.66666C1.19391 7.33334 0 6.13944 0 4.66666V2.66666C0 1.19391 1.19391 0 2.66666 0Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 0H13.3334C14.8062 0 16.0001 1.19391 16.0001 2.66666V4.66666C16.0001 6.13941 14.8062 7.33331 13.3334 7.33331H11.3334C9.86065 7.33331 8.66675 6.13941 8.66675 4.66666V2.66666C8.66672 1.19391 9.86062 0 11.3334 0Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66666 8.66699H4.66666C6.13941 8.66699 7.33331 9.8609 7.33331 11.3336V13.3336C7.33331 14.8064 6.13941 16.0003 4.66666 16.0003H2.66666C1.19391 16.0003 0 14.8064 0 13.3337V11.3337C0 9.8609 1.19391 8.66699 2.66666 8.66699Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 8.66699H13.3334C14.8062 8.66699 16.0001 9.8609 16.0001 11.3336V13.3336C16.0001 14.8064 14.8062 16.0003 13.3334 16.0003H11.3334C9.86065 16.0003 8.66675 14.8064 8.66675 13.3337V11.3337C8.66672 9.8609 9.86062 8.66699 11.3334 8.66699Z",
    fill: "#B0B0B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_739_1661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.5beb5bf679517467b6b9c58db1dc572b.svg";
export { ForwardRef as ReactComponent };